<ng-container *ngIf="mostrarPaginacao && total_pages > 1">
  <nav class="text-center clearfix">
    <ul class="pagination pagination-sm">
      <li class="{{ hasPrevPage ? 'disabled' : '' }}">
        <a
          href="javascript:void(0);"
          (click)="navegar({ page: page > 1 ? page - 1 : 1 })"
          aria-label="Previous"
        >
          <i class="fa fa-chevron-left" aria-hidden="true"></i>
          <span class="hidden-xs">Anterior</span>
        </a>
      </li>

      <li *ngIf="showNavPag(1)" class="{{ hasPrevPage ? 'disabled' : '' }}">
        <a
          href="javascript:void(0);"
          (click)="navegar({ page: 1 })"
          aria-label="Previous"
        >
          1 ...
        </a>
      </li>

      <ng-container *ngFor="let pag of showPages; let i = index">
        <li class="{{ page == pag ? 'active' : '' }}">
          <a href="javascript:void(0);" (click)="navegar({ page: pag })">{{
            pag
          }}</a>
        </li>
      </ng-container>

      <li
        *ngIf="showNavPag(total_pages)"
        class="{{ hasNextPage ? 'disabled' : '' }}"
      >
        <a
          href="javascript:void(0);"
          (click)="navegar({ page: total_pages })"
          aria-label="Previous"
        >
          ... {{ total_pages }}
        </a>
      </li>

      <li class="{{ hasNextPage ? 'disabled' : '' }}">
        <a
          href="javascript:void(0);"
          (click)="
            navegar({ page: total_pages > page ? page + 1 : total_pages })
          "
          aria-label="Next"
        >
          <span class="hidden-xs">Próxima</span>
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </a>
      </li>
    </ul>

    <div
      class="text-center text-info mb30 clearfix"
      style="margin-top: -22px; font-size: 11px"
    >
      Página {{ page }} de {{ total_pages }}, total de
      {{ total_items }} registros encontrados
    </div>
  </nav>
</ng-container>
